import api from "./api";
import { API_ENDPOINTS } from "../utils/constants";

/**
 * authService
 *
 * Purpose: Defines authentication API method signatures.
 * Used by: AuthContext and authentication components.
 */
export const authService = {
  // Sign-in is SSO-only — see components/Auth/LoginForm.jsx, which links
  // directly to API_ENDPOINTS.AUTH.MICROSOFT/GOOGLE as a full-page
  // navigation, and hooks/useSsoCallback.js, which consumes the tokens the
  // backend redirects back with.
  logout: async (refreshToken) => {
    const response = await api.post(API_ENDPOINTS.AUTH.LOGOUT, {
      refresh_token: refreshToken,
    });
    return response.data;
  },
  refresh: async (refreshToken) => {
    const response = await api.post(API_ENDPOINTS.AUTH.REFRESH, {
      refresh_token: refreshToken,
    });
    return response.data;
  },
  getMe: async () => {
    const response = await api.get(API_ENDPOINTS.AUTH.ME);
    return response.data;
  },
};

export default authService;
